import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

type TranslateFn = (key: string, params?: Record<string, unknown>) => string;

interface PlacesFilterBarProps {
    searchText: string;
    filterType: string;
    onSearchChange: (value: string) => void;
    onFilterChange: (value: string) => void;
    t: TranslateFn;
}

export const PlacesFilterBar: React.FC<PlacesFilterBarProps> = ({ searchText, filterType, onSearchChange, onFilterChange, t }) => {
    return (
        <Box sx={{ display: 'flex', gap: 2, mb: 3, alignItems: 'center', flexWrap: 'wrap' }}>
            <TextField
                placeholder={t('places.fields.search.placeholder')}
                value={searchText}
                onChange={e => onSearchChange(e.target.value)}
                sx={{ width: { xs: '100%', sm: 300 } }}
                InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} /> }}
            />
            <FormControl sx={{ minWidth: 150 }}>
                <InputLabel>{t('places.fields.type.label')}</InputLabel>
                <Select value={filterType} label={t('places.fields.type.label')} onChange={e => onFilterChange(e.target.value)}>
                    <MenuItem value="all">{t('places.fields.type.all')}</MenuItem>
                    <MenuItem value="food">{t('places.fields.type.food')}</MenuItem>
                    <MenuItem value="shopping">{t('places.fields.type.shopping')}</MenuItem>
                    <MenuItem value="attraction">{t('places.fields.type.attraction')}</MenuItem>
                    <MenuItem value="services">{t('places.fields.type.services')}</MenuItem>
                    <MenuItem value="emergency">{t('places.fields.type.emergency')}</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
};
